<div class="w-50 m-auto">
<ngx-attendance></ngx-attendance>
  
</div>

